import { FC, useState } from "react";
import { useDispatch } from "react-redux";

import Icon, { IconTypes } from "./../../../libs/Icon";
import { InputType } from "../../../libs/Input";
import GeneralSelect from "./GeneralSelect";
import Switch from "./../../../libs/Switch";
import Radio from "./../../../libs/Radio";

import { changeGeneralSettingsRequest } from "./../../../store/settings/actionCreators";
import { timeZoneOptions, languageOptions } from "./../../../store/settings/types";
import { selectFormGeneralSettings } from "./../../../store/settings/selectors";
import useShallowSelector from "./../../../hooks/useShalowSelector";
import { CaptchaTypes } from "./../../../store/settings/types";

import styles from "./styles.module.scss";

const General: FC = () => {
    const dispatch = useDispatch();
    const generalSettings = useShallowSelector(selectFormGeneralSettings);
    const [passwordValue, setPasswordValue] = useState<string>(generalSettings.setPassword.password);
    const [isShowPass, setIsShowPass] = useState<boolean>(false);
    const [timezones, setTimezones] = useState<string>(generalSettings.timeZone);
    const [languages, setLanguages] = useState<string>(generalSettings.language);

    const handleStateUpdate = (element: any) => {
        dispatch(
            changeGeneralSettingsRequest({
                prevState: generalSettings,
                currentState: {
                    ...generalSettings,
                    ...element,
                },
            }),
        );
    };

    return (
        <>
            <div className={styles.switchsContainer}>
                <div className={styles.switchBox}>
                    <Switch
                        checked={generalSettings.allowMultipleSubmissions}
                        onChange={() => {
                            handleStateUpdate({
                                allowMultipleSubmissions: !generalSettings.allowMultipleSubmissions,
                            });
                        }}
                    />

                    <label>Allow Multiple Submissions</label>
                </div>

                <div className={styles.switchBox}>
                    <Switch
                        checked={generalSettings.showFormTitle}
                        onChange={() => {
                            handleStateUpdate({
                                showFormTitle: !generalSettings.showFormTitle,
                            });
                        }}
                    />

                    <label>Show Form Title</label>
                </div>

                <div className={styles.switchBox}>
                    <Switch
                        checked={generalSettings.setPassword.isActive ? generalSettings.setPassword.isActive : false}
                        onChange={() => {
                            handleStateUpdate({
                                setPassword: {
                                    isActive: !generalSettings.setPassword.isActive,
                                    value: passwordValue,
                                },
                            });
                        }}
                    />

                    <label>Set Password</label>
                </div>

                {generalSettings.setPassword.isActive && (
                    <div className={styles.enterPassword}>
                        <input
                            className={styles.limitInput}
                            onChange={e => setPasswordValue(e.target.value)}
                            placeholder={"Enter Password"}
                            value={passwordValue}
                            type={isShowPass ? InputType.TEXT : InputType.PASSWORD}
                            onBlur={() => {
                                handleStateUpdate({
                                    setPassword: {
                                        isActive: generalSettings.setPassword.isActive,
                                        password: passwordValue,
                                    },
                                });
                            }}
                        />
                        <Icon
                            className={styles.isShowPass}
                            type={isShowPass ? IconTypes.EYE : IconTypes.EYE_OFF}
                            onClick={() => setIsShowPass(!isShowPass)}
                            size={24}
                        />
                    </div>
                )}
            </div>

            <div className={styles.sectionBox}>
                <h6> Show Captcha </h6>

                <Radio
                    className={styles.radio}
                    checked={generalSettings.showCaptcha === CaptchaTypes.CHECKBOX}
                    onChange={() => {
                        handleStateUpdate({
                            showCaptcha: CaptchaTypes.CHECKBOX,
                        });
                    }}
                    label="Google reCAPTCHA v2 (“I’m not a robot” - checkbox)"
                />
                <Radio
                    className={styles.radio}
                    checked={generalSettings.showCaptcha === CaptchaTypes.INVISIBLE}
                    onChange={() => {
                        handleStateUpdate({
                            showCaptcha: CaptchaTypes.INVISIBLE,
                        });
                    }}
                    label="Google reCAPTCHA v2 (Invisible reCAPTCHA)"
                />
            </div>

            <div className={styles.sectionBox}>
                <h6>Time Zone</h6>

                <GeneralSelect
                    setState={(newKey: string) => {
                        handleStateUpdate({
                            timeZone: newKey,
                        });
                        setTimezones(newKey);
                    }}
                    selectedItem={timezones}
                    options={timeZoneOptions}
                />
            </div>

            <div className={styles.sectionBox}>
                <h6>Language</h6>

                <GeneralSelect
                    setState={(newKey: string) => {
                        handleStateUpdate({
                            language: newKey,
                        });
                        setLanguages(newKey);
                    }}
                    selectedItem={languages}
                    options={languageOptions}
                />
            </div>
        </>
    );
};

export default General;
